import { computed, reactive } from 'vue'

export type LoadingMode = 'normal' | 'waiting'

export interface State {
  normalLoadingList: string[]
  waitLoadingList: string[]
}

const state = reactive<State>({
  normalLoadingList: [],
  waitLoadingList: []
})

// #region Getters

const isShowNormalLoading = computed(() => state.normalLoadingList.length > 0)

const isShowWaitLoading = computed(() => state.waitLoadingList.length > 0)

// #endregion

// #region Actions

const addLoading = (mode: LoadingMode, id: string): void => {
  if (mode === 'normal') {
    addNormalLoading(id)
  } else if (mode === 'waiting') {
    addWaitLoading(id)
  }
}

const removeLoading = (mode: LoadingMode, id: string): void => {
  if (mode === 'normal') {
    removeNormalLoading(id)
  } else if (mode === 'waiting') {
    removeWaitLoading(id)
  }
}

const addNormalLoading = (id: string): void => {
  const filteredNormalLoadingList = [...state.normalLoadingList].filter((loadingId) => loadingId !== id)
  state.normalLoadingList = [...filteredNormalLoadingList, id]
}

const removeNormalLoading = (id: string): void => {
  state.normalLoadingList = [...state.normalLoadingList].filter((loadingId) => loadingId !== id)
}

const addWaitLoading = (id: string): void => {
  const filteredWaitLoadingList = [...state.waitLoadingList].filter((loadingId) => loadingId !== id)
  state.waitLoadingList = [...filteredWaitLoadingList, id]
}

const removeWaitLoading = (id: string): void => {
  state.waitLoadingList = [...state.waitLoadingList].filter((loadingId) => loadingId !== id)
}

// #endregion

if (import.meta.hot) {
  import.meta.hot.on('vite:afterUpdate', () => {
    state.normalLoadingList = []
    state.waitLoadingList = []
  })
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useAppLoading () {
  return {
    isShowNormalLoading,
    isShowWaitLoading,
    // Actions
    addLoading,
    removeLoading
  }
}
